// extracted by mini-css-extract-plugin
export default {"root":"ContinueToPaymentButton_root__sf5Og","warning":"ContinueToPaymentButton_warning__WHVhG","button":"ContinueToPaymentButton_button__-QGt1"};